export default "__VITE_ASSET__BUh4oRpG__"